module.exports = __webpack_public_path__ + "static/img/CourseLists.387d272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CourseLists.png
// module id = 64
// module chunks = 1